// extracted by mini-css-extract-plugin
module.exports = {"button":"desktop-tile-type-button_button__OX7nB"};